
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "GCOFOTFMB",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/GCOFOTFMB.vue